// extracted by mini-css-extract-plugin
module.exports = {"optionsContainer":"MerchSizeOptions_optionsContainer__L07_r","option":"MerchSizeOptions_option__njw3w","selected":"MerchSizeOptions_selected__42AVT"};